export function validatePhoneNumber(phoneNumber) {
  // Define the regex for phone numbers
  const phoneRegex =
    /^[+]?(\d{1,3})?[-.\s]?(\d{3})[-.\s]?(\d{3,4})[-.\s]?(\d{4})$/;

  // Check if the phone number matches the pattern
  if (!phoneRegex.test(phoneNumber)) {
    return {
      valid: false,
      message: "Invalid phone number format.",
    };
  }

  // Optional: Length validation (e.g., ensure between 10 and 15 digits)
  const digitsOnly = phoneNumber.replace(/\D/g, ""); // Remove non-digit characters
  if (digitsOnly.length < 10 || digitsOnly.length > 13) {
    return {
      valid: false,
      message: "Phone number must be between 10 digits and 13 digits.",
    };
  }

  return { valid: true };
}

// Facility clock is Africa/Nairobi (UTC+3). The backend correctly embeds that
// offset in every timestamp it sends (e.g. "...+03:00"), but pulling the *UTC*
// getUTCHours()/getUTCDate()/etc. components back out — as this used to do —
// discards that offset and displays the UTC clock instead, 3 hours behind the
// real facility time. Formatting against an explicit "Africa/Nairobi" timeZone
// shows the correct facility-local time regardless of the viewer's own
// browser/OS timezone.
export function formatDateTime(isoString) {
  if (!isoString) return "";
  const date = new Date(isoString);
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Africa/Nairobi",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).formatToParts(date);

  const get = (type) => parts.find((p) => p.type === type)?.value;
  return `${get("day")} ${get("month")} ${get("year")}, ${get("hour")}:${get("minute")} ${get("dayPeriod")?.toUpperCase()}`;
}
